import { render, staticRenderFns } from "./RHm.vue?vue&type=template&id=8874ea64"
import script from "./RHm.vue?vue&type=script&lang=js"
export * from "./RHm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports